import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { SEO } from '../../utils/seo';

export default function InsuranceTermsPage() {
  const terms = [
    {
      number: '1',
      content: '차량 임차인 외 제 3 자에게 임대 및 운전을 맡기지 않겠으며, 제3자 운전중 사고 발생시 무보험 처리 (제3자 운전시)를 하게 됩니다.'
    },
    {
      number: '2',
      content: '종합 보험은 가입되어 있으며 종합 보험중 대인1(자배법 시행령에서 정한금액) 대인2(자배법)/대물 한사고당(5,000만원) 자손(1,500만원)까지 보험 회사에서 보상하며, 그 이상에 대해서는 임차인이 책임진다.'
    },
    {
      number: '3',
      content: '보험 처리시 할증부분 대인,대물, 각각(30만원씩이며) 자차 면책금 : (승용차외:50만원) (쏠라티 : 100만원)지불한뒤 보험처리를 한다.'
    },
    {
      number: '4',
      content: '중과실 12대 항목 위반 및 음주운전으로 인한 사고 및 100% 운전자 과실로 인한 사고 발생 시 자차보험 가입자도 보험처리는 안 된다'
    },
    {
      number: '5',
      content: '임차인 과실로 인한 단독 사고시 차량(수리비,휴차보상)등을 임차인이 전액보상 해야하며 (본인단독)으로 인한 차량 파손은 자차보험처리를 해줄 수 없다.'
    },
    {
      number: '6',
      content: '각종 교통법규 위반 주,정차위반,행정처분등 위반 시 (대한민국 관공서 및 관할 관청/에 신용정보제공 및 통보에 임차인이 전부 동의하며, 과태료는 전액(임차인)이 납부해야 한다.'
    },
    {
      number: '7',
      content: '차량 임차인은 대여 기간이 지나 당사에 사전 조치나 연락 없이 차량을 입고치 않을시 에 차량 도난 신고 시에 있어 당 사에 민형사상 어떠한 책음을 물을 수 없으며,사고 발생시 무보험 처리되며 본인 동의 없이 위치를 추적하여 차량을 회수하여도 민형사상 어떠한 책임이 없음을 확인 서명 날인 한다.'
    },
    {
      number: '8',
      content: '차량 강제회수 에 들어가는 소요경비(탁송비/차량 견인)비용 일체는 임차인이 부담한다.'
    },
    {
      number: '9',
      content: '차량 사고시 자차보험처리시 차량 견적은 각 차량 제조사 서비스센터 의 견적을 적용하며 차량 입고는 (주)누리렌트카의 지정 정비공장 입고를 원칙으로 한다.'
    },
    {
      number: '10',
      content: '차량 반납 지연시 1시간당 대여료의 10%의 추가요금이 발생 한다.'
    }
  ];

  const schema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "보험약관 - 대전렌트카",
    "description": "대전렌트카 차량 임대 시 필수로 확인해야 할 보험 및 손해배상 약관입니다. 임대 자동차 차량 파손 및 기타 손해배상 각서 전문.",
    "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/insurance-terms`,
    "isPartOf": {
      "@type": "WebSite",
      "name": "대전렌트카",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}`
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <SEO
        title="보험약관 - 임대 자동차 손해배상 각서 | 대전렌트카"
        description="대전렌트카 차량 임대 시 필수로 확인해야 할 보험 및 손해배상 약관입니다. 임대 자동차 차량 파손 및 기타 손해배상 각서 전문."
        keywords="대전렌트카 보험약관, 렌트카 손해배상, 자동차 임대 약관, 렌트카 보험 안내"
        canonical={`${import.meta.env.VITE_SITE_URL || 'https://example.com'}/insurance-terms`}
        schema={schema}
      />
      <Navbar />
      
      <main className="pt-20 md:pt-24">
        {/* Hero Section */}
        <section className="bg-gradient-to-r from-slate-600 to-gray-700 text-white py-12 md:py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center">
              <div className="w-16 h-16 md:w-20 md:h-20 flex items-center justify-center bg-white/10 backdrop-blur-sm rounded-2xl mx-auto mb-4 md:mb-6">
                <i className="ri-file-shield-2-line text-3xl md:text-4xl"></i>
              </div>
              <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-3 md:mb-4">
                보험약관
              </h1>
              <p className="text-base sm:text-lg md:text-xl text-white/90 max-w-3xl mx-auto">
                차량 임대 시 필수로 확인해야 할 보험 및 손해배상 약관입니다
              </p>
            </div>
          </div>
        </section>

        {/* Terms Content */}
        <section className="py-12 md:py-20">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
            {/* Title */}
            <div className="bg-white rounded-2xl shadow-lg p-6 md:p-8 mb-6 md:mb-8">
              <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-900 text-center">
                임대 자동차 차량 파손 및 기타 손해배상 각서
              </h2>
            </div>

            {/* Terms List */}
            <div className="space-y-4 md:space-y-6">
              {terms.map((term) => (
                <div 
                  key={term.number}
                  className="bg-white rounded-xl shadow-md hover:shadow-lg transition-shadow p-5 md:p-6"
                >
                  <div className="flex gap-4">
                    <div className="flex-shrink-0">
                      <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-gradient-to-br from-slate-500 to-gray-600 text-white rounded-full font-bold text-base md:text-lg">
                        {term.number}
                      </div>
                    </div>
                    <div className="flex-1 pt-1">
                      <p className="text-sm sm:text-base md:text-lg text-gray-700 leading-relaxed">
                        {term.content}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Special Notice */}
            <div className="mt-8 md:mt-12 bg-gradient-to-r from-amber-50 to-orange-50 border-l-4 border-amber-500 rounded-xl p-5 md:p-6">
              <div className="flex gap-3 md:gap-4">
                <div className="flex-shrink-0">
                  <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-amber-500 text-white rounded-full">
                    <i className="ri-star-line text-lg md:text-xl"></i>
                  </div>
                </div>
                <div className="flex-1">
                  <h3 className="text-base sm:text-lg md:text-xl font-bold text-gray-900 mb-2">
                    휴차료 적용 기준
                  </h3>
                  <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                    승용차 / 쏠라티 : 휴차료 적용기준 : 1일 임대료 (70% 적용함)
                  </p>
                </div>
              </div>
            </div>

            {/* Agreement Notice */}
            <div className="mt-6 md:mt-8 bg-slate-50 rounded-xl p-5 md:p-6 border border-slate-200">
              <div className="flex gap-3">
                <div className="flex-shrink-0 pt-1">
                  <i className="ri-information-line text-xl md:text-2xl text-slate-600"></i>
                </div>
                <div className="flex-1">
                  <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                    <strong className="text-gray-900">● 임차인 본인은</strong> 차량 임대계약서 뒷면에 기재된 대여 약관 및 계약서에 기재된 사항을 숙지하고 이를 승인하여 서명 날인 합니다.
                  </p>
                </div>
              </div>
            </div>

            {/* Important Warning */}
            <div className="mt-8 md:mt-12 bg-red-50 border border-red-200 rounded-xl p-5 md:p-6">
              <div className="flex gap-3 md:gap-4">
                <div className="flex-shrink-0">
                  <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-red-500 text-white rounded-full">
                    <i className="ri-alert-line text-lg md:text-xl"></i>
                  </div>
                </div>
                <div className="flex-1">
                  <h3 className="text-base sm:text-lg md:text-xl font-bold text-red-900 mb-2">
                    중요 안내사항
                  </h3>
                  <p className="text-sm sm:text-base text-red-800 leading-relaxed">
                    차량 임대 전 반드시 모든 약관을 숙지하시고, 궁금하신 사항은 담당자에게 문의해 주시기 바랍니다. 약관 미숙지로 인한 불이익은 임차인 본인에게 책임이 있습니다.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
